import { createInitialProgramState } from "./TranscriberProgramList.helpers";

const getProgramState = (state, programCode) =>
  state.programs[programCode] ?? createInitialProgramState(programCode);

export function Reducer(previousState = { programs: {} }, action) {
  const programCode = action.meta?.programCode;
  let newState = Object.assign({}, previousState);

  switch (action.type) {
    case "UPDATE_TRANSCRIBER_PROGRAM_FAX_SUCCESS": {
      const programState = getProgramState(newState, programCode);
      newState.programs = {
        ...newState.programs,
        [programCode]: {
          ...programState,
          data: action.payload.records,
          pages: action.payload.totalPages,
          totalElements: action.payload.totalElements,
          loading: false,
          isError: false,
          listState: {
            ...programState.listState,
            page: action.payload.page,
          },
        },
      };
      break;
    }
    case "UPDATE_TRANSCRIBER_PROGRAM_FAX_REQUEST": {
      const programState = getProgramState(newState, programCode);
      newState.programs = {
        ...newState.programs,
        [programCode]: {
          ...programState,
          listState: action.payload.listState,
          totalElements: "Loading ...",
          loading: true,
          isError: false,
        },
      };
      break;
    }
    case "UPDATE_TRANSCRIBER_PROGRAM_FAX_INDEX_ON_LIST": {
      const programState = getProgramState(newState, programCode);
      newState.programs = {
        ...newState.programs,
        [programCode]: {
          ...programState,
          indexOnList: action.indexOnList,
        },
      };
      break;
    }
    case "UPDATE_TRANSCRIBER_PROGRAM_FAX_FAILURE": {
      const programState = getProgramState(newState, programCode);
      newState.programs = {
        ...newState.programs,
        [programCode]: {
          ...programState,
          data: [],
          pages: 0,
          totalElements: 0,
          loading: false,
          isError: true,
        },
      };
      break;
    }
    case "RESET_ERROR_MESSAGE_TRANSCRIBER_PROGRAM_FAX": {
      const programState = getProgramState(newState, programCode);
      newState.programs = {
        ...newState.programs,
        [programCode]: {
          ...programState,
          isError: false,
        },
      };
      break;
    }
    default:
      break;
  }

  return newState;
}
